import DealerSettings from '../../../../appmodules/users-settings/dealer-settings';
import DuplicatePinPlateSearchSettings from '../../../../appmodules/duplicate-pin-plate-search/duplicate-pin-plate-admin-search';
import DuplicatePinPlateSettings from '../../../../appmodules/duplicate-pin-plate-settings/components';
import Notifications from '../../../../appmodules/notifications';
import PinSearchSettings from '../../../../appmodules/product-settings/pin-search';
import PinTransferSettings from '../../../../appmodules/pin-transfer-settings/pin-transfer-search';
import Welcome from '../../../../appmodules/welcome';

const userItems = [
    {
        title: 'UserPersonalization',
        path: '/welcome/dealer',
        component: DealerSettings,
    },
];

const pinSearchItems = [
    {
        title: 'PinSearch',
        path: '/welcome/pin-search',
        component: PinSearchSettings,
    },
];
const pinItems = [
    {
        title: 'PinTransfer',
        path: '/welcome/pin-transfer',
        component: PinTransferSettings,
    },
];
const duplicatePinPlateItems = [
    {
        title: 'DuplicatePinPlate',
        path: '/welcome/duplicate-pin-plate',
        component: DuplicatePinPlateSettings,
    },
    {
        title: 'DuplicatePinPlateSearch',
        path: '/welcome/duplicate-pin-plate-search',
        component: DuplicatePinPlateSearchSettings,
    },
];

export const adminConfiguration = [
    {
        id: 'notifications',
        name: 'NOTIFICATIONS',
        path: '/welcome/notifications',
        component: Notifications,
    },
    {
        id: 'Userinfomation',
        title: 'USER',
        accordion: true,
        childRoute: [...userItems],
    },
    {
        id: 'pin-search-infomation',
        title: 'PIN SEARCH',
        accordion: true,
        childRoute: [...pinSearchItems],
    },
    {
        id: 'pin-transfer-infomation',
        title: 'DEALER',
        accordion: true,
        childRoute: [...pinItems],
    },
    {
        id: 'duplicate-pin-Plate-request',
        title: 'ADMIN',
        accordion: true,
        childRoute: [...duplicatePinPlateItems],
    },
];

export const welcome = [
    {
        path: '/',
        component: Welcome,
        exact: true,
        isSecureRoute: true,
        childRoute: [...adminConfiguration],
    },
    {
        path: '/welcome',
        component: Welcome,
        isSecureRoute: true,
        childRoute: [...adminConfiguration],
    },
];
